import { createLink } from '@tanstack/react-router';
import { forwardRef, ReactNode } from 'react';
import { Tab, TabProps } from '@optimus-web/core';

export type LinkTabProps = { children: ReactNode; 'data-status'?: string; to?: string } & Omit<
    TabProps,
    'id' | 'value' | 'label'
> & { id?: string; value?: string };

export const LinkTab = createLink(
    forwardRef(({ children, ...other }: LinkTabProps, _ref: React.ForwardedRef<HTMLAnchorElement>) => (
        <Tab as="a" {...(other as TabProps)} label={children} active={other['data-status'] === 'active'} />
    ))
);
